import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { Editor, EditorTextChangeEvent } from "primereact/editor";
import { useToast } from "../../utils/toast";
import AdminService from "../../services/admin/admin.services";

const EditPresidentMessageComponent = () => {
  const toast = useToast();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    loadPresidentMessage();
  }, []);

  const loadPresidentMessage = async () => {
    try {
      const response = await AdminService.getPresidentMessage();
      if (response?.result?.data) {
        setContent(response.result.data.content);
      }
    } catch (error) {
      toast.show("Başkan mesajı yüklenirken bir hata oluştu.", "error");
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await AdminService.updatePresidentMessage({
        content
      });

      if (response?.result) {
        toast.show("Başkan mesajı başarıyla güncellendi.", "success");
      } else {
        setError("Güncelleme sırasında bir hata oluştu.");
      }
    } catch (error) {
      toast.show("Bir hata oluştu, lütfen tekrar deneyiniz.", "error");
    } finally {
      setLoading(false);
    }
  };

  const editorHeader = (
    <div className="flex align-items-center gap-2 m-2">
      <span className="text-xl font-bold">Başkan Mesajı Düzenle</span>
    </div>
  );

  const editorStyle = `
    .p-editor-container .ql-editor h1,
    .p-editor-container .ql-editor h2,
    .p-editor-container .ql-editor h3,
    .p-editor-container .ql-editor h4,
    .p-editor-container .ql-editor h5,
    .p-editor-container .ql-editor h6,
    .preview-content h1,
    .preview-content h2,
    .preview-content h3,
    .preview-content h4,
    .preview-content h5,
    .preview-content h6 {
      color: var(--primary-color);
      margin-bottom: 0.5rem;
      margin-top: 0rem;
    }

    /* Dropdown menülerin arka planı */
    .ql-snow .ql-picker-options {
      background-color: var(--surface-ground) !important;
      border: 1px solid var(--surface-border) !important;
      border-radius: 6px;
      padding: 0.5rem;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    /* Dropdown menü seçenekleri hover efekti */
    .ql-snow .ql-picker-options .ql-picker-item:hover {
      background-color: var(--surface-hover) !important;
      color: var(--primary-color) !important;
    }

    /* Seçili seçeneğin stili */
    .ql-snow .ql-picker-options .ql-selected {
      color: var(--primary-color) !important;
    }

    /* Renk paletinin arka planı */
    .ql-color-picker .ql-picker-options,
    .ql-background .ql-picker-options {
      background-color: var(--surface-ground) !important;
      padding: 0.5rem !important;
    }
  `;

  return (
    <div className="flex flex-column justify-content-center p-0">
      <style>{editorStyle}</style>
      <Card className="mb-3">
        <form onSubmit={handleSubmit} className="flex flex-column gap-3">
          {error && <Message severity="error" text={error} className="w-full" />}

          <div className="flex flex-column gap-2">
            <Editor
              value={content}
              onTextChange={(e: EditorTextChangeEvent) => setContent(e.htmlValue ?? "")}
              style={{ height: "320px" }}
              headerTemplate={editorHeader}
              pt={{
                toolbar: { className: "surface-ground" }
              }}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, 4, 5, 6, false] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ color: [] }, { background: [] }],
                  [{ size: ["small", "normal", "large", "huge"] }],
                  [{ align: [] }],
                  ["blockquote", "code-block"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link", "image"],
                  ["clean"]
                ]
              }}
            />
          </div>

          <Button
            type="submit"
            label={loading ? "Kaydediliyor..." : "Kaydet"}
            icon="pi pi-save"
            loading={loading}
            disabled={loading || !content}
            className="w-full mt-3"
          />
        </form>
      </Card>

      <Card title="Mevcut Başkan Mesajı" className="mb-3">
        <div
          className="preview-content"
          dangerouslySetInnerHTML={{ __html: content }}
          style={{
            padding: "1rem",
            backgroundColor: "white",
            borderRadius: "4px",
            minHeight: "200px"
          }}
        />
      </Card>
    </div>
  );
};

export default EditPresidentMessageComponent;
